if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      hide() {
        super.hide();
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
      showActiveMedia() {
        // Get the media ID from the opener (thumbnail button)
        let targetMediaId = this.openedBy.getAttribute("data-media-id");

        // If no data-media-id on the button, try to get it from the parent thumbnail
        if (!targetMediaId) {
          const thumbnail = this.openedBy.closest("[data-target]");
          if (thumbnail) {
            targetMediaId = thumbnail.getAttribute("data-target");
          }
        }

        // If still no target, try to get it from the closest media item
        if (!targetMediaId) {
          const mediaItem = this.openedBy.closest("[data-media-id]");
          if (mediaItem) {
            targetMediaId = mediaItem.getAttribute("data-media-id");
          }
        }

        console.log("Original target media ID:", targetMediaId); // Debug log

        // Check if we have a translated media mapping
        const sectionId = this.id.replace("ProductModal-", "");
        if (
          window.translatedMediaMapping &&
          window.translatedMediaMapping[sectionId]
        ) {
          const mapping = window.translatedMediaMapping[sectionId];
          if (mapping[targetMediaId]) {
            targetMediaId = mapping[targetMediaId];
            console.log("Mapped to translated ID:", targetMediaId); // Debug log
          }
        }

        // Remove active class from all modal items
        this.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("active");
        });

        // Find and activate the target media
        const activeMedia = this.querySelector(
          `[data-media-id="${targetMediaId}"]`
        );

        if (activeMedia) {
          console.log("Found active media:", activeMedia); // Debug log

          const activeMediaTemplate = activeMedia.querySelector("template");
          const activeMediaContent = activeMediaTemplate
            ? activeMediaTemplate.content
            : null;
          activeMedia.classList.add("active");
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
          if (
            activeMedia.nodeName == "DEFERRED-MEDIA" &&
            activeMediaContent &&
            activeMediaContent.querySelector(".js-youtube")
          )
            activeMedia.loadContent();
        } else {
          console.warn("No active media found for ID:", targetMediaId); // Debug log

          // Fallback: show the first item if no match found
          const firstItem = this.querySelector("[data-media-id]");
          if (firstItem) {
            firstItem.classList.add("active");
          }
        }
      }
    }
  );
}
